import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpStatusCodes } from '../models/http/http-status-codes.model';
import { ValidationErrorMessageModel } from '../models/validation/validation-error-message.model';
import { ToasterService } from '../services/toaster/toaster.service';

@Injectable({ providedIn: 'root' })
export class HttpErrorResponseInterceptor implements HttpInterceptor {
  constructor(private readonly toasterService: ToasterService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.headers.has('hide-errors')) {
      return next.handle(req.clone({ headers: req.headers.delete('hide-errors') }));
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === HttpStatusCodes.badRequest && this.showValidationErrors(error)) {
          return EMPTY;
        }

        if (
          error.status === HttpStatusCodes.unprocessableEntity &&
          this.showUnprocessableEntityError(error)
        ) {
          return EMPTY;
        }

        if (error.status === HttpStatusCodes.forbidden) {
          this.showForbiddenWarning();
          return EMPTY;
        }

        return throwError(() => error);
      }),
    );
  }

  private showValidationErrors(error: HttpErrorResponse): boolean {
    const validationErrors: ValidationErrorMessageModel[] =
      error.error?.error?.validationErrors ?? [];

    if (validationErrors.length === 0) {
      return false;
    }

    const message = validationErrors.map(e => e.message).join('\n');
    this.toasterService.error(message);
    return true;
  }

  private showForbiddenWarning(): void {
    this.toasterService.warn('::NoPermissionForOperation', '::Warning');
  }

  private showUnprocessableEntityError(error: HttpErrorResponse): boolean {
    const remoteError = error.error?.error as { code?: string; message?: string } | undefined;
    const localizedMessage = remoteError?.message || '::UnexpectedErrorMessage';
    this.toasterService.error(localizedMessage);
    return true;
  }
}
